<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box learn-header">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item to="/study">学习</el-breadcrumb-item>
          <el-breadcrumb-item>提交订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="page-inner-box learn-content">
        <!-- 左侧内容区 -->
        <div class="left">
          <!-- 收货地址区域 -->
          <el-card class="address-card" shadow="never">
            <div class="section-title">
              <i class="el-icon-location-outline"></i>
              收货地址
            </div>
            <div class="address-content">
              <div class="address-info" v-if="selectedAddress">
                <div class="default-tag" v-if="selectedAddress.isDefault">默认</div>
                <div class="contact-info">
                  <span class="name">{{ selectedAddress.name }}</span>
                  <span class="phone">{{ selectedAddress.phone }}</span>
                </div>
                <div class="address-detail">
                  {{ selectedAddress.province }}{{ selectedAddress.city }}{{ selectedAddress.district }}{{ selectedAddress.detail }}
                </div>
                <div class="address-actions">
                  <el-button type="text" @click="editAddress">编辑</el-button>
                  <el-button type="text" @click="setDefault">设为默认</el-button>
                </div>
              </div>
              <div class="add-address" @click="addNewAddress">
                <i class="el-icon-plus"></i>
                添加新地址
              </div>
            </div>
          </el-card>

          <!-- 订单信息区域 -->
          <el-card class="order-card" shadow="never">
            <div class="section-title">
              <i class="el-icon-document"></i>
              订单信息
            </div>
            <div class="order-content">
              <div class="product-info">
                <div class="product-image">
                  <img :src="product.image" alt="商品图片" />
                </div>
                <div class="product-details">
                  <div class="product-title">{{ product.name }}</div>
                  <div class="product-options">
                    <el-tag size="small" class="version-tag">{{ product.version }}</el-tag>
                    <el-tag size="small" class="package-tag">{{ product.package }}</el-tag>
                  </div>
                </div>
                <div class="product-price">
                  <span class="price">¥{{ product.price.toFixed(2) }}</span>
                  <span class="quantity">×{{ product.quantity }}</span>
                  <span class="quantity-mark">{{ product.quantity }}</span>
                </div>
              </div>
              <!-- 商品总额信息 -->
              <div class="product-total">
                <span class="total-label">1件商品，总商品金额：</span>
                <span class="total-value">¥{{ totalPrice.toFixed(2) }}</span>
              </div>
            </div>
          </el-card>
        </div>

        <!-- 右侧内容区 -->
        <div class="right">
          <!-- 提交订单区域 -->
          <el-card class="submit-card" shadow="never">
            <div class="submit-content">
              <!-- 总商品金额 -->
              <div class="total-amount-info">
                <span class="total-amount-text">1件商品，总商品金额：</span>
                <span class="total-amount-value">¥{{ totalPrice.toFixed(2) }}</span>
              </div>
              
              <!-- 应付总额和提交按钮 -->
              <div class="final-order">
                <div class="final-price">
                  <span class="final-label">应付总额：</span>
                  <span class="final-value">¥{{ totalPrice.toFixed(2) }}</span>
                </div>
                <el-button type="primary" size="large" @click="submitOrder" class="final-submit-btn">提交订单</el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
export default {
  name: 'PhysicalOrderPayment',
  data() {
    return {
      // 收货地址数据
      addressList: [
        {
          id: 1,
          name: '王雨',
          phone: '13812341234',
          province: '北京市',
          city: '北京市',
          district: '海淀区',
          detail: '万林大厦八层',
          isDefault: true
        }
      ],
      selectedAddress: null,
      // 商品数据
      product: {
        id: 1,
        name: '吧宝贝学习机',
        image: 'https://via.placeholder.com/100x100?text=Learning+Machine',
        version: '新版',
        package: '普通包装',
        price: 2000.00,
        quantity: 1
      }
    }
  },
  computed: {
    totalPrice() {
      return this.product.price * this.product.quantity
    }
  },
  created() {
    // 初始化时选择默认地址
    this.selectedAddress = this.addressList.find(addr => addr.isDefault) || this.addressList[0]
  },
  methods: {
    // 添加新地址
    addNewAddress() {
      this.$router.push('/address')
    },
    // 编辑地址
    editAddress() {
      this.$message.info('编辑地址功能待实现')
    },
    // 设置默认地址
    setDefault() {
      this.addressList.forEach(addr => {
        addr.isDefault = addr.id === this.selectedAddress.id
      })
      this.$message.success('已设置为默认地址')
    },
    // 提交订单
    submitOrder() {
      this.$confirm('确定要提交订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('订单提交成功')
        // 这里可以添加跳转到支付页面的逻辑
        // this.$router.push({ name: 'payment', params: { id: this.product.id } })
      }).catch(() => {
        this.$message.info('已取消提交')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 20px;
}

/* 左右分栏布局 */
.learn-content {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

/* 确保内容居中，使用全局样式定义 */
.page-inner-box {
  /* 移除组件内的重新定义，使用global.scss中的样式 */
}

.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.right {
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 卡片样式 */
.address-card,
.order-card,
.submit-card {
  margin-bottom: 12px;
}

.address-content,
.order-content,
.submit-content {
  padding: 10px 0;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
}

.section-title i {
  margin-right: 8px;
  color: #3E2CCD;
}

/* 收货地址样式 */
.address-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.address-info {
  flex: 1;
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  position: relative;
}

.default-tag {
  position: absolute;
  top: 0;
  left: 0;
  background: #f56c6c;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 8px 0 8px 0;
}

.contact-info {
  margin-bottom: 10px;
}

.name {
  font-weight: 600;
  margin-right: 20px;
  color: #303133;
}

.phone {
  color: #606266;
}

.address-detail {
  color: #606266;
  line-height: 1.5;
  margin-bottom: 10px;
}

.address-actions {
  display: flex;
  gap: 10px;
}

.add-address {
  width: 150px;
  height: 100px;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  cursor: pointer;
  transition: all 0.3s;
}

.add-address:hover {
  border-color: #409eff;
  color: #409eff;
}

.add-address i {
  font-size: 24px;
  margin-bottom: 8px;
}

/* 订单信息样式 */
.order-content {
  padding: 15px 0;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-details {
  flex: 1;
}

.product-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.product-options {
  display: flex;
  gap: 10px;
}

.version-tag,
.package-tag {
  background-color: #e0e0ff !important;
  color: #4034eb !important;
  border-color: #e0e0ff !important;
  font-size: 12px !important;
}

.product-price {
  text-align: right;
  display: flex;
  align-items: center;
  gap: 15px;
}

.price {
  font-size: 18px;
  font-weight: 700;
  color: #4034eb;
}

.quantity {
  color: #606266;
  font-size: 14px;
}

.quantity-mark {
  width: 20px;
  height: 20px;
  background-color: #ff4d4f;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

/* 商品总额信息 */
.product-total {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  font-size: 14px;
}

.product-total .total-label {
  color: #606266;
  margin-right: 10px;
}

.product-total .total-value {
  color: #303133;
  font-weight: 600;
}

/* 提交订单样式 */
.submit-card {
  border: none;
  box-shadow: none;
}

.submit-content {
  padding: 0;
}

/* 总商品金额 */
.total-amount-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
  padding: 0;
}

.total-amount-text {
  color: #606266;
  margin-right: 10px;
}

.total-amount-value {
  color: #303133;
  font-weight: 600;
}

/* 应付总额和提交按钮 */
.final-order {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f0f0ff;
  padding: 20px;
  border-radius: 8px;
  flex-direction: row-reverse;
}

.final-price {
  display: flex;
  align-items: center;
  gap: 10px;
}

.final-label {
  font-size: 16px;
  font-weight: 600;
  color: #606266;
}

.final-value {
  font-size: 20px;
  font-weight: 700;
  color: #ff4d4f;
}

.final-submit-btn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  background-color: #4034eb !important;
  border-color: #4034eb !important;
  border-radius: 8px;
  color: #fff !important;
}

.final-submit-btn:hover {
  background-color: #3329c7 !important;
  border-color: #3329c7 !important;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .learn-content {
    flex-direction: column;
  }
  
  .right {
    width: 100%;
  }
}
</style>
